import React, {Component} from "react";
import {connect} from "react-redux";
import {SET_TICKET_LIST_RELOAD} from "../../actions/types";

import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import TumbnailImg from "./TumbnailImg";
import DisplayImage from "./DisplayImage";
import ErrorMessage from "../CommonComponents/ErrorMessage";
import SuccessMessage from "../CommonComponents/SuccessMessage";

import UserDetails from "../UserDetails/UserDetails";
import attactment from "../../svg/additional.svg";

import api from "../../api/api";

class NewReportTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMessage: {
                title: "New Support Ticket",
                description: "Write a new ticket",
                backIcon: false,
                moreOptionhidden: true,
                searchOptionHidden: true
            },
            submitBtnDisable: true,
            imgFiles: [],
            displayImage: false,
            imageNo: 0,
            fileToDisplay: null,
            displayErrorPopup: false,
            displaySuccessPopup: false,
            reportedName: "Playo User",
            reportedId: ""
        };
    }

    /**
     * this is for history or goback
     */
    goBack = () => {
        if (!this.state.displayImage) {
            window.open("/faqclose", "_self");
        } else {
            this.setState({
                displayImage: false
            });
        }
    };

    showSuccess = () => {
        this.setState({
            displaySuccessPopup: true
        });
    };

    onEnableSubmitBtn = () => {
        if (document.getElementById("ticketDesc").value.trim().length > 0) {
            this.setState({
                submitBtnDisable: false
            });
        } else {
            this.setState({
                submitBtnDisable: true
            });
        }
    };

    fileUploadClick = () => {
        document.getElementById("fileUpload").click();
    };

    getFileList = event => {
        if (event.target.files.length > 0) {
            this.setState({
                imgFiles: [...this.state.imgFiles, event.target.files[0]]
            });
        }
        document.getElementById("fileUpload").files = null;
    };

    onSubmitBtnClick = () => {
        const {userId, email, fName, name, mobile, city, countryCode, userIdv2} = this.props;
        const playoId = userIdv2 || userId;
        const {reportedName, reportedId} = this.state;
        api.displayMainLoader();
        this.setState({
            submitBtnDisable: true
        });
        let uploadFilesId = [];
        this.state.imgFiles.forEach(file => {
            api
                .uploadAttachment(file)
                .then(data => {
                    uploadFilesId = [...uploadFilesId, data.data.upload.token];
                    if (uploadFilesId.length === this.state.imgFiles.length) {
                        let dataToSend = {
                            title: `Report Abuse: ${reportedName}`,
                            description: document.getElementById("ticketDesc").value,
                            imageArray: uploadFilesId
                        };
                        api
                            .createNewTicket(dataToSend, playoId, email, name, mobile, city, countryCode, reportedId)
                            .then(data => {
                                this.setState({
                                    submitBtnDisable: false,
                                    imgFiles: []
                                });
                                this.props.ticketUpdated();
                                api.displayHideLoader();
                                this.showSuccess();
                            })
                            .catch(error => {
                                this.setState({
                                    displayErrorPopup: true
                                });
                                api.displayHideLoader();
                            });
                    }
                })
                .catch(error => {
                    this.setState({
                        displayErrorPopup: true
                    });
                    api.displayHideLoader();
                });
        });
        if (this.state.imgFiles.length === 0) {
            let dataToSend = {
                title: `Report Abuse: ${reportedName}`,
                description: document.getElementById("ticketDesc").value,
                imageArray: uploadFilesId
            };
            api
                .createNewTicket(dataToSend, playoId, email, name, mobile, city, countryCode, reportedId)
                .then(data => {
                    this.setState({
                        submitBtnDisable: false
                    });
                    this.props.ticketUpdated();
                    api.displayHideLoader();
                    this.showSuccess();
                })
                .catch(error => {
                    this.setState({
                        displayErrorPopup: true
                    });
                    api.displayHideLoader();
                });
        }
    };

    onTumbnailClick = no => {
        --no;
        this.setState({
            displayImage: true,
            imageNo: no,
            fileToDisplay: this.state.imgFiles[no]
        });
    };

    deleteOption = no => {
        this.setState({
            displayImage: false,
            imgFiles: this.state.imgFiles.splice(no, -1)
        });
    };

    errorCloseCLick = () => {
        this.setState({
            displayErrorPopup: false
        });
    };

    componentDidMount() {
        const {match} = this.props;
        const reportedId = match && match.params && match.params.repotedUser;
        this.setState({
            reportedId: reportedId
        });
        api
            .getUserDataV2(reportedId)
            .then(data => {
                const {fName, lName} = data;
                this.setState({
                    reportedId: reportedId,
                    reportedName: `${fName} ${lName}`
                });
            })
            .catch(err => {
                console.log("Err", err);
            });
        api.displayHideLoader();
    }

    render() {
        const {fName, email} = this.props;
        const {reportedName} = this.state;
        let i = 0;
        // return <UserDetails />;
        const headerObj = {
            title: "Report",
            description: "Write a new ticket",
            backIcon: false,
            moreOptionhidden: true,
            searchOptionHidden: true
        };
        return fName && email ? (
            <div>
                {this.state.displayImage ? (
                    <DisplayImage
                        deleteOption={this.deleteOption.bind(this)}
                        no={this.state.imageNo}
                        image={this.state.fileToDisplay}
                        displayDeleteBtn={true}
                        back={this.goBack.bind(this)}
                    />
                ) : (
                    ""
                )}
                {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)}/> : null}
                {this.state.displaySuccessPopup ? (
                    <SuccessMessage message="Your report is registered" onCloseClick={this.goBack}/>
                ) : null}

                <HelpAndSupportHeader displayMessage={headerObj} back={this.goBack.bind(this)}/>
                <div className="body-container">
                    {/* <div className="ticket-box-container">
            <div className="ticket-box">
              <div className="ticket-box-title">REASON</div>
              <input
                type="text"
                id="ticketTitle"
                className="ticket-box-input"
                placeholder="Give your report a title"
                maxLength="64"
                style={{ paddingLeft: 0 }}
                onChange={this.onEnableSubmitBtn.bind(this)}
              />
            </div>
          </div> */}
                    <div className="article-body">
                        You are reporting {reportedName}. Playo Support might get in touch with you to get the details
                        of the
                        incident. Please note that in severe cases the user is blocked from Playo upon this report.
                    </div>
                    <div className="ticket-box-container" style={{marginTop: "15px"}}>
                        <div className="ticket-box">
                            <div className="ticket-box-title">DESCRIPTION</div>
                            <textarea
                                id="ticketDesc"
                                className="ticket-description-textarea"
                                placeholder="Describe the incident"
                                maxLength="512"
                                style={{paddingLeft: 0}}
                                onChange={this.onEnableSubmitBtn.bind(this)}
                            />
                        </div>
                    </div>
                    {this.state.imgFiles.map(image => {
                        return (
                            <TumbnailImg
                                image={image}
                                key={++i}
                                no={i}
                                onTumbnailClick={this.onTumbnailClick.bind(this)}
                                imageLink={false}
                            />
                        );
                    })}
                    <div className="ticket-attactment-icon-area" onClick={this.fileUploadClick.bind(this)}>
                        <img src={attactment} alt="" className="ticket-attactment-icon"/>
                        <label className="ticket-attactment-label">Attach screenshot if required</label>
                        <input type="file" id="fileUpload" hidden={true} onChange={this.getFileList.bind(this)}
                               accept="image/*"/>
                    </div>
                </div>
                <div className="submit-btn-container">
                    <input
                        type="button"
                        className="submit-btn"
                        disabled={this.state.submitBtnDisable}
                        onClick={this.onSubmitBtnClick.bind(this)}
                        value="Report"
                    />
                </div>
            </div>
        ) : (
            <UserDetails/>
        );
    }
}

const mapStateToProps = (
    {
        userId,
        email,
        name,
        fName,
        mobile,
        city,
        countryCode,
        userIdv2
    }) => ({
        userId,
        email,
        name,
        fName,
        mobile,
        city,
        countryCode,
        userIdv2
    }
);

const mapDispatchToProps = dispatch => {
    return {
        ticketUpdated: () => {
            dispatch({
                type: SET_TICKET_LIST_RELOAD,
                payload: true
            });
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewReportTicket);



// WEBPACK FOOTER //
// ./src/components/Tickets/NewReportTicket.js